module.exports = __webpack_public_path__ + "static/img/pos_pay_detail2.af42b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_pay_detail2.png
// module id = 70OF
// module chunks = 8